import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Paper, Typography, Container, useTheme, useMediaQuery } from '@mui/material';
import flowImg from "../../../assets/images/inspection.flow.jpg";
import backgImg from "../../../assets/images/backg.jpg";

const HowItWorksSection = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const steps = [
    {
      title: t('how_it_works.step1_title', 'Buyer Requests Inspection'),
      desc: t('how_it_works.step1_desc', 'The buyer requests the inspection for the product.'),
      position: { top: '13%', left: '68%' },
      mobilePosition: { top: '10%', left: '50%' },
    },
    {
      title: t('how_it_works.step2_title', 'Seller Brings Camera to Checkpoint'),
      desc: t('how_it_works.step2_desc', 'Seller brings the camera to the checkpoint for inspection.'),
      position: { top: '39%', left: '30%' },
      mobilePosition: { top: '30%', left: '50%' },
    },
    {
      title: t('how_it_works.step3_title', 'Camera Inspection Process'),
      desc: t('how_it_works.step3_desc', 'Camera inspection process takes place at the checkpoint.'),
      position: { top: '63%', left: '68%' },
      mobilePosition: { top: '50%', left: '45%' },
    },
    {
      title: t('how_it_works.step4_title', 'Buyer Makes Decision'),
      desc: t('how_it_works.step4_desc', 'Based on the inspection, the buyer makes the decision.'),
      position: { top: '88%', left: '30%' },
      mobilePosition: { top: '70%', left: '50%' },
    },
  ];

  return (
    <Box
      sx={{
        py: 12,
        position: 'relative',
        width: '100%',
        backgroundImage: `url(${backgImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        mt: '0%', // Move the whole component 10% lower
      }}
    >
      <Container>
        {/* Header Text */}
        <Box sx={{ textAlign: 'center', mb: 1, mt: '5%' }}>
          <Typography
            variant="h4"
            sx={{ fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' }, fontWeight: 'bold' }}
          >
            {t('how_it_works.main_title', 'How it works?')}
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}
          >
            {t('how_it_works.subtitle', 'It works simple in 4 steps')}
          </Typography>
        </Box>

        {/* Image with Steps */}
        <Box sx={{ position: 'relative', width: '100%' }}>
          <img
            src={flowImg}
            alt="Inspection Flow"
            style={{
              width: '100%',
              height: 'auto',
              borderRadius: '8px',
              objectFit: 'contain',
            }}
          />

          {/* Steps on top of the image */}
          {steps.map((step, index) => (
            <Box
              key={index}
              sx={{
                position: 'absolute',
                top: isMobile ? step.mobilePosition.top : step.position.top,
                left: isMobile ? step.mobilePosition.left : step.position.left,
                transform: 'translate(-50%, -50%)',
                textAlign: 'center',
                zIndex: 5,
                width: { xs: '80%', sm: '220px' },
              }}
            >
              <Paper
                elevation={4}
                sx={{
                  p: 2,
                  borderRadius: 2,
                  border: '2px solid #ccc',
                  backgroundColor: '#fff',
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: { xs: '1rem', sm: '1.1rem' } }}>
                  {step.title}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {step.desc}
                </Typography>
              </Paper>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default HowItWorksSection;
